<script>
	import listBase from '@_system/components/base/list.vue'
	import ordertrackcodeIndex from './ordertrackcode/index.vue'
	import customerList from '@/components/forms/offer/box/customer/list.vue'
	import configIndex from './lib/config/index.vue'
	import pushForm from './form/push.vue'
	
	export default {
		extends: listBase,
		name: 'offerIndex',
		props: {

		},
		data() {
			return {
				configdata:{},
				moduleName: 'offer',
				windowName: '报价单',
				windowType: 'window',
				address:'',
				row: null,
				statusShow: false,
				statusTitle: '订单状态',
				statusForm: {
					status: ''
				},
				defaultFormValue:[]
				//windowType:'window'
			}
		},
		render(h) {
			this.$slots.plug = [ 
				<ordertrackcode-index title = "跟单二维码" ref = "ordertrackcodeIndex" />,
				<customer-list ref="customerList" onSubmit={this.customerListSubmit} />,
				<push-form ref="pushForm" data={this.row} onSubmit={this.pushFormSubmit} />,
				<config-index ref="configIndex" data={this.configdata} />,
			]
			return listBase.render.call(this, h)
		},
		watch: {

		},
		created() {
			
		},
		mounted() {
			// console.log(this.$store.state)
			this.defaultFormValue.push({
				field:"staffid",
				default:[this.$store.state.system.user.id]
			})
		},
		computed: {

		},

		methods: {
			config(){
				this.loading = true
				this.$api.config.get(0,{module:'offer'}).then((res)=>{
					this.configdata = res
					this.$refs.configIndex.modal_show()
					this.loading = false
				},()=>{
					this.loading = false
				})
			},
			customerListSubmit(e){
				// console.log(e)
				this.pushhandle(e.data)
			},
			push(row){
				this.row = row
				this.address = row.customeraddress
				this.$refs.pushForm.modal_show()
				// this.$confirm('是否确认推送', '提示', {
				// 	confirmButtonText: '确定',
				// 	cancelButtonText: '取消',
				// 	type: 'warning'
				// }).then(() => {					
				// 	this.pushhandle()
				// }).catch(() => {
				// 	this.loading = false
				// })

			},
			pushFormSubmit(e){
				this.address = e.customeraddress
				this.pushhandle()
			},
			pushhandle(customer){
				this.loading = true
				this.$api.offer.push({
					id: this.row.id,
					address:this.address,
					customer:customer
				}).then((res) => {
					if(res == 99){
						this.$refs.customerList.modal_show()
						this.$message.error('万里牛客户不存在，请选择客户')
					}else{
						this.customreload()
					}
					this.loading = false						
				},()=>{
					this.loading = false
				})			
			},
			close(row){
				this.row = row
				this.$confirm('是否确认关闭', '提示', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					type: 'warning'
				}).then(() => {					
					this.loading = true
					this.$api.offer.close({
						id: this.row.id
					}).then(() => {
						this.$message.success('关闭成功')
						this.customreload()
						this.loading = false						
					},()=>{
						this.loading = false
					})	
				}).catch(() => {
					this.loading = false
				})
			
			},

			
			ordertrackcode(){
				this.$refs.ordertrackcodeIndex.modal_show()
			},
			addformShow(extra = {}) {
				if (this.windowType == 'window') {
					let res = this.$router.resolve({
						name: 'add',
						query: {
							name: this.moduleName,
							id: 0,
							controlltype: 1,
							windowName: '新建' + this.windowName,
							foreingKey: JSON.stringify({}),
							extra: JSON.stringify(extra)
						}
					})
					let win = window.open(res.href, this.moduleName + 'add' + Math.random(),
						this.$store.state.system.windowConfig)
					win.onload = () => {

					}
				} else {
					this.formModule = {
						name: this.moduleName,
						id: 0,
						controlltype: 1,
						windowName: '新建' + this.windowName,
						foreingKey: {},
						extra: extra
					}
					this.formwindowShow = true
				}
			},
			cellStyle({
				row
			}) {
				if (row.status == 7961) {
					return {
						background: 'rgb(253, 226, 226)'
					}
				}
				if (row.status == 7960) {
					return {
						background: 'rgb(250, 236, 216)'
					}
				}
			},
			undeal(row) {
				this.$api.offer.updatefromlist(row.id, {
					status: 7960
				}).then(() => {
					this.customreload()
				})
			},
			deal(row) {
				this.$api.offer.updatefromlist(row.id, {
					status: 7961
				}).then(() => {
					this.customreload()
				})
			},
			statusSubmit() {
				this.$api.offer.setStatus(this.row.id, this.statusForm).then(() => {
					this.$message.success('操作成功')
					this.statusShow = false
					this.statusForm.status = ''
					this.customreload()
				})

			}
		},
		components: {
			ordertrackcodeIndex,
			customerList,
			configIndex,
			pushForm
		}
	}
</script>